import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, catchError, map, of, throwError } from 'rxjs';
import { AppSettings } from '../app-settings';
import { CommonService } from './common.service';

@Injectable({
  providedIn: 'root'
})
export class ShoppingCartService {

  private modifyCart = new BehaviorSubject<any>(null);
  public updateCartObservable = this.modifyCart.asObservable();

  private cartUser = new BehaviorSubject<any>(null);
  public cartUserObservable = this.cartUser.asObservable();

  constructor(private http: HttpClient) { }

  setModifyCart(cart: any) {
    this.modifyCart.next(cart);
  }

  getLastCart() {
    return this.cartUser.getValue();
  }

  getCartUser(idCart?: number) {
    let url = `${AppSettings.API_URI_V2}/cart`;
    if(idCart) {
      url += `/${idCart}`;
    }
    return this.http.get<any>(url).pipe(
      map((res) => {
        if (res && res.data?.cart && res.data?.cart?.ttl > 0) {
          this.cartUser.next(res.data?.cart);
        } else {
          this.cartUser.next(null);
        }
        return res;
      })
    );
  }

  addBondToCard(payload: any) {
    const url = `${AppSettings.API_URI_V2}/cart/addPass`;
    return this.http.post<any>(url, payload).pipe(
      map(data => {
        return data;
      }),
      catchError(err => { return throwError(() => err); })
    );
  }

  /**
   * Abono en butaca única (obligatoria u ofrecida): solo se mandan el abono y
   * las butacas; la entrada de cada evento y las líneas del carrito las
   * resuelve el back. `event_id` va cuando las butacas se eligieron en el
   * mapa de un evento y no en el del abono.
   */
  addSingleSeatPass(payload: { id_discount: number; seat_ids: number[]; event_id?: number | null }) {
    const url = `${AppSettings.API_URI_V2}/cart/addSingleSeatPass`;
    return this.http.post<any>(url, payload).pipe(
      map(data => {
        return data;
      }),
      catchError(err => { return throwError(() => err); })
    );
  }

  addToCart(payload: any) {
    const url = `${AppSettings.API_URI_V2}/cart`;
    return this.http.post<any>(url, payload).pipe(
      map(data => {
        return data;
      }),
      catchError(err => { return throwError(() => err); })
    );
  }

  updateCartLineSimple(idLine: number, payload: any) {
    const url = `${AppSettings.API_URI_V2}/cart-line/${idLine}`;
    return this.http.put<any>(url, payload).pipe(
      map(data => {
        return data;
      })
    );
  }

  deleteItemToCart(idLine: number) {
    const url = `${AppSettings.API_URI_V2}/cart-line/${idLine}`;
    return this.http.delete<any>(url).pipe(
      map(data => {
        return data;
      })
    );
  }

  deleteCart(idCart: number) {
    const url = `${AppSettings.API_URI_V2}/cart/${idCart}`;
    return this.http.delete<any>(url).pipe(
      map(data => {
        return data;
      })
    );
  }

}
